// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"53aae4fb","281":"21eaca13","326":"0dd457ba","333":"dbf726d6","609":"83132eef","970":"0b48dd95"}[chunkId] + ".chunk.js";
};